// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"autoBreadcrumbs_breadcrumbs__L5+72"};